import { rootReducer } from './reducer/reducers.index';
import * as actions from './action/action.index';
import setupStoreCommon from './setupStore';
import types from './types';
var setupStore = function (_a) {
    var _b = _a === void 0 ? {} : _a, initialState = _b.initialState, shouldUseDBStorage = _b.shouldUseDBStorage;
    return setupStoreCommon(rootReducer, initialState, shouldUseDBStorage);
};
export { setupStore, actions, rootReducer, types };
